export function readCartMessage(messages, namespace, path, fallback = '') {
  const source = messages?.[namespace] || {};
  const resolved = path
    .split('.')
    .reduce((current, segment) => current?.[segment], source);

  return typeof resolved === 'string' ? resolved : fallback;
}

export function interpolateCartMessage(template, values = {}) {
  if (typeof template !== 'string' || !template) {
    return '';
  }

  return template.replace(/{{\s*([^}]+?)\s*}}/g, (_, key) => {
    const nextValue = values[key.trim()];
    return nextValue == null ? '' : String(nextValue);
  });
}
